import React from 'react';

export default ({ fillColor }) => (
  <svg
    id="footer-background"
    xmlns="http://www.w3.org/2000/svg"
    width="1440"
    height="203.727"
    viewBox="0 0 1440 203.727"
  >
    <path
      id="Path_303"
      data-name="Path 303"
      d="M-2573,6071.111s522.062,17.161,970.806-10.318S-1133,6023.4-1133,6023.4v203.727H-2573Z"
      transform="translate(2573 -6023.396)"
      fill="#FFFFFF"
    />
    <path
      id="Path_303"
      data-name="Path 303"
      d="M-2573,6071.111s522.062,17.161,970.806-10.318S-1133,6023.4-1133,6023.4v203.727H-2573Z"
      transform="translate(2573 -6023.396)"
      fill={`${fillColor ? `${fillColor}10` : '#f5f2fe'}`}
    />
  </svg>
);
